export default function contains(array, item) {
    return array.indexOf(item) > -1;
}
